import axios from "axios";

const TOKEN_KEY = "aplus_access_token";

export function getToken() {
    try { return localStorage.getItem(TOKEN_KEY) || ""; }
    catch { return ""; }
}
export function setToken(v) {
    try {
        if (v) localStorage.setItem(TOKEN_KEY, v);
        else localStorage.removeItem(TOKEN_KEY);
    } catch { /* ignore */ }
}

const api = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
    withCredentials: true,     // keep cookies as a fallback for same-site deploys
    timeout: 20000,
});

// Attach Authorization: Bearer <token> when we have one. This makes the app
// work in cross-site deployments where SameSite cookies aren't sent.
api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

/**
 * Convert any axios/HTTP error into a friendly, user-facing string.
 */
export function formatApiError(err) {
    const status = err?.response?.status;
    if (!err?.response) {
        return "Unable to reach the server. Check your connection and try again.";
    }
    if (status === 401) {
        const url = err?.config?.url || "";
        if (url.includes("/auth/login")) {
            return "Invalid email or password.";
        }
        return "Your session has expired — please sign in again.";
    }
    if (status === 403) {
        return "You don't have access to perform this action.";
    }
    if (status >= 500) {
        return "The server hit an error — please retry in a moment.";
    }
    const detail = err?.response?.data?.detail;
    if (Array.isArray(detail)) {
        return detail.map(d => d.msg || JSON.stringify(d)).join(", ");
    }
    if (typeof detail === "string") return detail;
    if (detail) return JSON.stringify(detail);
    return err?.message || "Request failed.";
}

export default api;
